import {
  FeatureServiceBinder,
  FeatureServiceProviderDefinition,
  SharedFeatureService,
} from '@feature-hub/core';
import {FaContentServiceV1, FaContentServiceV1Impl} from './v1';

export * from './v1';

export interface SharedFaContentService extends SharedFeatureService {
  readonly '1.0.0': FeatureServiceBinder<FaContentServiceV1>;
}

export const faContentServiceDefinition: FeatureServiceProviderDefinition<SharedFaContentService> = {
  id: 'fa-content-service',

  create: () => {
    return {
      '1.0.0': () => ({
        featureService: new FaContentServiceV1Impl(),
      }),
    };
  },
};
